import {
  resolveSpeakUpButtonText,
  resolveSpeakUpF2SUPopUpDescription,
} from '@helpers/speakUpConfig.helper';
import { useAppSelector } from '@hooks/useAppSelector';
import { useMemo } from 'react';
import { RootState } from 'store';

export const useSpeakUpCompanyConfig = () => {
  const speakUpConfig = useAppSelector((state: RootState) => state.companyConfig.data);

  return useMemo(
    () => ({
      buttonText: resolveSpeakUpButtonText(speakUpConfig.speakUpButtonText),
      f2suPopUpDescription: resolveSpeakUpF2SUPopUpDescription(
        speakUpConfig.speakUpF2SUPopUpDescription,
      ),
    }),
    [speakUpConfig.speakUpButtonText, speakUpConfig.speakUpF2SUPopUpDescription],
  );
};
